import { Directive } from '@angular/core';

@Directive({
  selector: '[nttHint]',
  host: {
    class: 'ntt-form-field__hint',
  },
})
export class NttHint {}
